module.exports = __webpack_public_path__ + "public/images/generated-explore-geography.f0fe4af82587c821a31b6faaa5bfd7a5.jpg";